/* tslint:disable */
/* eslint-disable */
/**
 * Bank Accounts API
 * API for managing bank accounts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankAccountDto } from './BankAccountDto';
import {
    BankAccountDtoFromJSON,
    BankAccountDtoFromJSONTyped,
    BankAccountDtoToJSON,
    BankAccountDtoToJSONTyped,
} from './BankAccountDto';

/**
 * 
 * @export
 * @interface GetBankAccountListResponseDto
 */
export interface GetBankAccountListResponseDto {
    /**
     * Indicates if the operation was successful
     * @type {boolean}
     * @memberof GetBankAccountListResponseDto
     */
    isSuccess: boolean;
    /**
     * Error message if the operation failed
     * @type {string}
     * @memberof GetBankAccountListResponseDto
     */
    errorMessage?: string | null;
    /**
     * List of bank accounts
     * @type {Array<BankAccountDto>}
     * @memberof GetBankAccountListResponseDto
     */
    bankAccounts: Array<BankAccountDto>;
}

/**
 * Check if a given object implements the GetBankAccountListResponseDto interface.
 */
export function instanceOfGetBankAccountListResponseDto(value: object): value is GetBankAccountListResponseDto {
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('bankAccounts' in value) || value['bankAccounts'] === undefined) return false;
    return true;
}

export function GetBankAccountListResponseDtoFromJSON(json: any): GetBankAccountListResponseDto {
    return GetBankAccountListResponseDtoFromJSONTyped(json, false);
}

export function GetBankAccountListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBankAccountListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'bankAccounts': ((json['bankAccounts'] as Array<any>).map(BankAccountDtoFromJSON)),
    };
}

export function GetBankAccountListResponseDtoToJSON(json: any): GetBankAccountListResponseDto {
    return GetBankAccountListResponseDtoToJSONTyped(json, false);
}

export function GetBankAccountListResponseDtoToJSONTyped(value?: GetBankAccountListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'errorMessage': value['errorMessage'],
        'bankAccounts': ((value['bankAccounts'] as Array<any>).map(BankAccountDtoToJSON)),
    };
}

